// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-section {
  border-bottom: 1px solid var(--grey-light3);
  background-color: var(--primary-20);
  position: relative; }
  .header-section .logo {
    width: 40px;
    height: 40px; }
    .header-section .logo img {
      object-fit: contain; }

.header-menu {
  z-index: 100; }
  .header-menu .menu-icon {
    width: 32px;
    height: 32px;
    padding: 6px;
    border-radius: 50%;
    cursor: pointer; }
    .header-menu .menu-icon:hover {
      background-color: rgba(0, 0, 0, 0.2); }
  .header-menu .menu {
    position: absolute;
    top: 100%;
    left: 4px;
    width: calc(100% - 8px);
    background-color: white;
    box-shadow: 0 0 10px 5px #e1e1e1; }
    .header-menu .menu .link {
      width: 100%;
      padding: 12px;
      font-size: 14px;
      font-weight: 600;
      color: var(--text-1);
      border-bottom: 1px solid var(--white); }
      .header-menu .menu .link:hover, .header-menu .menu .link.active {
        background-color: var(--primary-05);
        color: var(--primary-100); }
  .header-menu .hide-menu {
    height: 0;
    visibility: hidden; }
  .header-menu .show-menu {
    height: unset;
    visibility: visible; }

@media all and (max-width: 768px) {
  .header-section {
    justify-content: space-between !important; }
  .logo-text {
    display: none; } }

@media all and (min-width: 769px) {
  .header-menu {
    display: none; } }
`, "",{"version":3,"sources":["webpack://./src/component/header/header.scss"],"names":[],"mappings":"AAAA;EACI,2CAA2C;EAC3C,mCAAmC;EACnC,kBAAkB,EAAA;EAHtB;IAKQ,WAAW;IACX,YAAY,EAAA;IANpB;MAQY,mBAAmB,EAAA;;AAK/B;EACI,YAAY,EAAA;EADhB;IAGQ,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe,EAAA;IAPvB;MASY,oCAAiC,EAAA;EAT7C;IAaQ,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,uBAAuB;IACvB,uBAAuB;IACvB,gCAAgC,EAAA;IAlBxC;MAoBY,WAAW;MACX,aAAa;MACb,eAAe;MACf,gBAAgB;MAChB,oBAAoB;MACpB,qCAAqC,EAAA;MAzBjD;QA2BgB,mCAAmC;QACnC,yBAAyB,EAAA;EA5BzC;IAiCQ,SAAS;IACT,kBAAkB,EAAA;EAlC1B;IAqCQ,aAAa;IACb,mBAAmB,EAAA;;AAI3B;EACI;IACI,yCAAyC,EAAA;EAE7C;IACI,aAAa,EAAA,EAChB;;AAGL;EACI;IACI,aAAa,EAAA,EAChB","sourcesContent":[".header-section {\n    border-bottom: 1px solid var(--grey-light3);\n    background-color: var(--primary-20);\n    position: relative;\n    .logo {\n        width: 40px;\n        height: 40px;\n        img {\n            object-fit: contain;\n        }\n    }\n}\n\n.header-menu {\n    z-index: 100;\n    .menu-icon {\n        width: 32px;\n        height: 32px;\n        padding: 6px;\n        border-radius: 50%;\n        cursor: pointer;\n        &:hover {\n            background-color: rgba(0,0,0,0.2);\n        }\n    }\n    .menu {\n        position: absolute;\n        top: 100%;\n        left: 4px;\n        width: calc(100% - 8px);\n        background-color: white;\n        box-shadow: 0 0 10px 5px #e1e1e1;\n        .link {\n            width: 100%;\n            padding: 12px;\n            font-size: 14px;\n            font-weight: 600;\n            color: var(--text-1);\n            border-bottom: 1px solid var(--white);\n            &:hover, &.active {\n                background-color: var(--primary-05);\n                color: var(--primary-100);\n            }\n        }\n    }\n    .hide-menu {\n        height: 0;\n        visibility: hidden;\n    }\n    .show-menu {\n        height: unset;\n        visibility: visible;\n    }\n}\n\n@media all and (max-width: 768px) {\n    .header-section {\n        justify-content: space-between !important;\n    }\n    .logo-text {\n        display: none;\n    }\n}\n\n@media all and (min-width: 769px) {\n    .header-menu {\n        display: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
